export default __webpack_public_path__ + "static/media/Hashtag.13f2613e.svg";